import React, { useState, useEffect, useCallback } from "react";
import {
  faEdit,
  faFlag,
  faRotateRight,
  faIndianRupeeSign,
  faEye,
  faDownload,
  faPrint,
} from "@fortawesome/free-solid-svg-icons";
import JSONPretty from "react-json-pretty";
import html2canvas from "html2canvas";
import { withAppHOC } from "../../../hoc";
import PageHeading from "../../../components/PageHeader/PageHeader";
import LoadingSpinner from "../../../components/LoadingSpinner/LoadingSpinner";
import NoData from "../../../components/NoData/NoData";
import StatusHighliter from "../../../components/StatusHighliter/StatusHighliter";
import {
  MessageBox,
  CustomButton,
  Label,
  Fieldset,
  TextInput,
  Button,
  Form,
  ResetButton,
  Dropdown,
  FormContainer,
  UpdateButton,
  CustomConfirmButton,
  NumberInput,
} from "../../../components/FormElements";
import { TableBuilder } from "../../../components/TableElements";
import Modal from "../../../components/Modal";
import OverlayLoader from "../../../components/OverlayLoader/OverlayLoader";
import {
  StyledFiltersContainer,
  StyledModalContainer,
  StyledRechargeCountsContainer,
  StyledRechargeCounter,
  StyledHeader,
  StyledBodyContainer,
  StyledHeading,
  StyledContent,
  StyledApiCallLogsContainer,
  StyledSpan,
} from "../../../components/Styled";
import Pagination from "../../../components/Pagination/Pagination";
import API from "../../../api";
import {
  ACCOUNT_TYPES,
  API_RESPONSE_TYPES,
  PERMISSION_TYPES,
} from "../../../constants";
import {
  getSearchParams,
  authData,
  formatCurrency,
  shouldRedirect,
  redirectToPageOne,
  generateExistingInvoicePDF,
} from "../../../utils";
import FiltersButton from "../../../components/FiltersButton/FiltersButton";
import Accordination from "../../../components/Accordination/Accordination";
import { Grid, GridItem } from "../../../components/Grid";
import TransactionInvoice from "./TransactionInvoice";
import moment from "moment";
import { filter } from "lodash";

const TransactionsTable = (props) => {
  const { accountType } = authData.get();
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams("pageNumber") || 1,
    recordsPerPage: getSearchParams("recordsPerPage") || 100,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalTransactionsId, setModalTransactionsId] = useState("");
  const [apiTransactionsId, setApiTransactionsId] = useState("");
  const [apiOperatorsId, setApiOperatorsId] = useState("");
  const [operators, setOperators] = useState([]);
  const [apiProviders, setApiProviders] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [number, setNumber] = useState("");
  const [filterAmount, setfilterAmount] = useState("");
  const [operatorsId, setOperatorsId] = useState("");
  const [apiProvidersId, setApiProvidersId] = useState("");
  const [transactionsId, setTransactionsId] = useState("");
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [transactionsStatus, setTansactionsStatus] = useState("");
  const [rolesId, setRolesId] = useState("");
  const [accountsId, setAccountsId] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [rechargeCounts, setRechargeCounts] = useState({});
  const [modalType, setModalType] = useState("");
  const [logs, setLogs] = useState([]);
  const [supervisorsId, setSupervisorsId] = useState("");
  const [staffsId, setStaffsId] = useState("");
  const [printAmount, setPrintAmount] = useState("");
  const [printAppName, setPrintAppName] = useState("");
  const [printAccountName, setPrintAccountName] = useState("");
  const [printData, setPrintData] = useState(null);
  const [lapuNumber, setLapuNumber] = useState("");

  const [printApp, setPrintApp] = useState("");

  const readApiLogs = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/transactions/logs/${id}`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setLogs(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleApiLogs = (id) => {
    setModalType("API_LOGS");
    setShowModal(true);
    readApiLogs(id);
  };

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetForm = () => {
    setRolesId("");
    setAccountsId("");
    setSupervisorsId("");
    setStaffsId("");
    setNumber("");
    setfilterAmount("");
    setOperatorsId("");
    setTransactionsId("");
    setTansactionsStatus("");
    setApiProvidersId("");
    setLapuNumber("");
    setStartDate(moment().format("YYYY-MM-DD"));
    setEndDate(moment().format("YYYY-MM-DD"));
    readData(
      "",
      "",
      "",
      "",
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      "",
      "",
      "",
      ""
    );
    readRechargeCounts(
      "",
      "",
      "",
      "",
      moment().format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD"),
      "",
      "",
      "",
      ""
    );
  };

  const resetModalForm = () => {
    setApiTransactionsId("");
    setApiOperatorsId("");
  };

  const readAccounts = () => {
    API.get("/accounts-management/accounts").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setAccounts(data);
      }
    });
  };

  const readOperators = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/recharge-configurations/operators`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setOperators(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readApiProviders = useCallback(() => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/recharge-configurations/api-providers`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setApiProviders(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const readRechargeCounts = useCallback(
    (
      number = "",
      filterAmount = "",
      operatorsId = "",
      transactionsId = "",
      transactionsStatus = "",
      startDate = "",
      endDate = "",
      apiProvidersId = "",
      accountsId = "",
      supervisorsId = "",
      staffsId = ""
    ) => {
      setIsLoading(true);
      setResponseStatus("");
      setResponseMessage("");
      API.get(
        `/transactions/recharge-counts/?transactionsId=${transactionsId}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`
      )
        .then((response) => {
          const { status, data } = response.data;
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setRechargeCounts(data[0]);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    []
  );

  const readData = useCallback(
    (
      number = "",
      filterAmount = "",
      operatorsId = "",
      transactionsId = "",
      transactionsStatus = "",
      startDate = "",
      endDate = "",
      apiProvidersId = "",
      accountsId = "",
      supervisorsId = "",
      staffsId = ""
    ) => {
      setIsLoading(true);
      setResponseStatus("");
      setResponseMessage("");
      API.get(
        `/transactions/?transactionsId=${transactionsId}&pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`
      )
        .then((response) => {
          const { status, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            if (status === API_RESPONSE_TYPES.SUCCESS) {
              setTotalRecords(pageInfo.totalRecords);
            }
            setTransactions(data);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILURE);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  const raiseDispute = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.put(
      `/transactions/raise-dispute/${id}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&transactionsId=${transactionsId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const refundTransaction = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.put(
      `/transactions/refund/${id}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&transactionsId=${transactionsId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const updateTransaction = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.put(
      `/transactions/update/${modalTransactionsId}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`,
      {
        apiTransactionsId,
        apiOperatorsId,
      }
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
            resetModalForm();
            setTimeout(() => {
              setShowModal(false);
              setModalTransactionsId("");
              resetResponseData();
            }, 3000);
          } else {
            setTimeout(() => {
              resetResponseData();
            }, 3000);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const reloadTransaction = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(
      `/transactions/reload/${id}?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&transactionsId=${transactionsId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`
    )
      .then((response) => {
        const { status, message, data, pageInfo } = response.data;
        if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
          redirectToPageOne();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          if (status === API_RESPONSE_TYPES.SUCCESS) {
            setTransactions(data);
            setTotalRecords(pageInfo.totalRecords);
          }
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const reloadData = () => {
    readData(
      number,
      filterAmount,
      operatorsId,
      transactionsId,
      transactionsStatus,
      startDate,
      endDate,
      apiProvidersId,
      accountsId,
      supervisorsId,
      staffsId
    );
    readRechargeCounts(
      number,
      filterAmount,
      operatorsId,
      transactionsId,
      transactionsStatus,
      startDate,
      endDate,
      apiProvidersId,
      accountsId,
      supervisorsId,
      staffsId
    );
  };

  const filterData = (e) => {
    e.preventDefault();
    setIsFiltering(true);
  };

  const onClickExport = () => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(
      `/transactions/export?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&transactionsId=${transactionsId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`
    )
      .then((response) => {
        const { status, message } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
          setTimeout(() => {
            setResponseStatus("");
            setResponseMessage("");
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onClickHeavyReload = () => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(
      `/transactions/heavy-reload/?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&faccountsId=${accountsId}&number=${number}&operatorsId=${operatorsId}&apiProvidersId=${apiProvidersId}&transactionsId=${transactionsId}&startDate=${startDate}&endDate=${endDate}&transactionsStatus=${transactionsStatus}&disputeStatus=&supervisorsId=${supervisorsId}&staffsId=${staffsId}&filterAmount=${filterAmount}`
    )
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILURE) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          setTransactions(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const printInvoice = async (e) => {
    e.preventDefault();

    if (!printApp) {
      alert("Please select provider");
      return;
    }
    setModalType("");
    setShowModal(false);

    if (printApp === "MOBIKWIK") {
      const win = window.open(
        `/transactions/MobikwikDetails/${printData.id}`,
        "_blank",
        "noopener,noreferrer"
      );

      if (win) {
        win.invoiceData = printData;
      } 
      return; // ⛔ VERY IMPORTANT — STOP HERE
    }

    const table = document.getElementById(
      `print-${printApp}-print-${printData.id}`
    );

    const newWindow = window.open("", "_blank");
    if (newWindow) {
      newWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
      <style>
        ${printApp === "MROBOTICS"
          ? `
          table {
              padding: 10px;
              width: 100%;
              border-collapse: collapse;
              font-family: Verdana, Geneva, Tahoma, sans-serif;
              text-align: left;
              color: #5e7d8a;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
          }

          th {
              border-top: none;
              border-bottom: none;
              vertical-align: middle;
              padding: 0.45rem 1.25rem;
              font-weight: 500;
              color: #324148;
              font-size: 14px;
              text-transform: capitalize;
          }

          td {
              font-size: 15px;
              padding: 0.45rem 1.25rem;
              border-top: 1px solid #eaecec;
              vertical-align: middle;
              white-space: nowrap;
          }

          img {
              max-width: 45px;
          }

          .operatorsid{
          font-size: 12px;
            color: #848d91 !important;
            display: block;
            padding-top: 5px;
          }
          .rechargeid {
              text-decoration: none;
              color: #00acf0;
              -webkit-transition: color 0.2s ease;
              -moz-transition: color 0.2s ease;
              transition: color 0.2s ease;
          }

          .status {
              background: #22af47;
              color: #fff;
              font-weight: 500;
              border-radius: 4px;
              padding: 5px 7px;
              font-size: 72%;
              letter-spacing: 0.3px;
              vertical-align: middle;
              display: inline-block;
              text-align: center;
              text-transform: capitalize;
          }

          .btn-group {
              position: relative;
              display: -ms-inline-flexbox;
              display: inline-flex;
              vertical-align: middle;
          }

          button {
              height: 35px;
              width: 35px;
              color: #324148;
              background-color: transparent;
              background-image: none;
              border: 2px solid #eaecec;
              text-transform: capitalize;
              outline: none;
          }

          button:first-child {
              border-top-left-radius: 5px;
              border-bottom-left-radius: 5px;
          }

          button:last-child {
              margin-left: -2px;
              border-top-right-radius: 5px;
              border-bottom-right-radius: 5px;
          }

          .btn-icon-wrap {
              font-size: 13px;
          }
              @media print {
    img {
      display: block !important;
      visibility: visible !important;
    }
  }
          `
          : printApp === "CSC"
            ? `@media print {

  * {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    background: #fff !important;
    color: #222;
    font-family: Roboto, 'Segoe UI', 'Droid Sans', Tahoma, Arial, sans-serif;
    font-weight: 400;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* ================= FIXED RECEIPT SIZE ================= */
  #print-CSC,
  [id^="print-CSC-"] {
    width: 752px !important;
    max-width: 752px !important;
    margin: 0 auto !important;
    padding: 16px !important;
    background: #fff !important;
    overflow: hidden !important;
  }

  @page {
    size: 752px;
    margin: 0;
  }

  img {
    display: block !important;
    max-width: 100% !important;
    height: auto !important;
  }

  /* ================= HEADER ================= */
  .csc-header {
    font-size: 22px;
    font-weight: 400; /* 🔧 FIX — lighter like original */
  }

  .csc-sub-id {
    font-size: 14px;
    font-weight: 400;
    color: #8c8c8c;
  }

  /* ================= SECTION TITLES ================= */
  .csc-section-title {
    font-size: 16px;
    font-weight: 400; /* 🔧 FIX — NOT medium/bold */
    margin: 16px 0 8px;
  }

  /* ================= TABLE BASE ================= */
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
    margin-bottom: 12px;
  }

  table tbody tr:nth-child(odd) {
    background-color: #fafafa !important;
  }

  table tbody tr:nth-child(even) {
    background-color: #ffffff !important;
  }

  td {
    border: 1px solid #f0f0f0;
    padding: 6px 10px;
    vertical-align: middle;
    background: transparent !important;
  }

  /* LABEL COLUMN */
  td:first-child {
    font-weight: 400;
    width: 45%;
  }

  /* VALUE COLUMN — ✅ EXACT MATCH */
  td:last-child {
    font-weight: 500 !important; /* 🔧 FIX — 500, NOT 600 */
  }

  /* TOTAL AMOUNT */
  .text-success,
  .csc-total {
    color: #46ca89 !important;
    font-weight: 500 !important; /* 🔧 FIX */
  }

  /* ================= FOOTER ================= */
  .text-center {
    text-align: center;
    font-size: 14px;
    margin-top: 12px; /* 🔧 tighter */
    margin-bottom: 6px;
    font-weight: 400;
  }

  .text-center b {
    font-weight: 500;
  }

  /* ================= THERMAL PRINT SPACING ================= */
  .thermal-print-wrapper {
    margin-top: 6px !important; /* 🔧 FIX GAP */
  }

  .thermal-note {
    margin-top: 4px !important;
  }

  /* ================= BUTTONS ================= */
  button {
    display: none !important;
  }
}
`
            : printApp === "REALROBO"
              ? `
           @media print {
    img {
      display: block !important;
      visibility: visible !important;
    }
  }
      table {padding: 10px;
        width: 100%;
        color: #3f4254;
        background-color: transparent;
        border-collapse: collapse;
        font-family: Poppins, Helvetica, "sans-serif";
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }

      thead {
        background-color: #f4f6f9;
      }

      th {
        font-weight: 600;
        color: #b5b5c3 !important;
        font-size: 12px;
        text-transform: uppercase;
        padding: 12px;
        text-align: left;
        background-color: #f4f6f9;
      }

      td {
        font-size: 13px;
        text-align: left;
      }

      .orderid {
        font-weight: bold;
        color: #3445e5;
        padding-bottom: 5px;
      }

      .datetime {
        font-weight: bold;
        display: block;
      }

      .mobile {
        font-size: 13px;
      }

      .circle {
        font-size: 11px;
        color: #8950fc;
        line-height: 15px;
        display: block;
      }

      .somenumber {
        font-size: 12px;
        color: #b5b5c3;
      }

      .lapu {
        color: #8950fc;
        cursor: pointer;
        font-size: 11px;
      }

      .success-pill {
        color: #fff;
        background-color: #1bc5bd;
        padding: .15rem .75rem;
        border-radius: .42rem;
        font-size: .8rem;
      }

      .svg {
        color: #b5b5c3;
        height: 1.5rem !important;
        width: 1.5rem !important;
      }

      .pic {
        width: 100%;
        max-width: 50px;
        height: 50px;
      }
          `
              : `
          @media print {
    img {
      display: block !important;
      visibility: visible !important;
    }
  }
          table {padding: 10px;
              font: 14px "Open Sans", Helvetica, Arial, sans-serif;
              width: 100% !important;
              font-size: 12px;
              margin: 0 auto;
              clear: both;
              border-collapse: separate;
              border-spacing: 0;
              vertical-align: middle !important;
              color: #212529;
              background-color: #ffff !important;
              caption-side: bottom;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
          }

          th {
              padding: 10px 5px !important;
              background: #d0f0ff !important;
              color: black !important;
              border: 1px solid rgb(0 0 0 / 9%) !important;
              text-align: center !important;
              font-size: 12px;
          }

          td {
              padding: 8px 3px !important;
              border: 1px solid rgb(0 0 0 / 9%) !important;
              text-align: center !important;
              white-space: nowrap;
          }

          .status {
              background: #05891b;
              color: #fff;
              padding: 2px 12px 2px 10px !important;
              font-size: 12px;
              display: inline-block;
              width: 100px;
              text-align: center;
              border-radius: 2rem;
          }
          `
        }
      </style>
      </head>
      <body>
      ${table.outerHTML}
      </body>
      </html>`);

      // newWindow.document.close(); // Close the document to ensure it’s fully loaded.
      // newWindow.focus(); // Bring the new window into focus.
      // newWindow.print(); // Trigger the print dialog.
      // newWindow.close(); // Optionally close the window after printing.
      setTimeout(async () => {
        const container = newWindow.document.getElementById(
          `print-${printApp}-print-${printData.id}`
        );
        try {
          const canvas = await html2canvas(container, {
            useCORS: true,
            scale: 2,
          });

          const image = canvas.toDataURL("image/png");
          const link = document.createElement("a");
          link.href = image;
          link.download = `transaction-${printData.id}.png`;
          link.click();
        } catch (error) {
          console.error("Failed to generate image:", error);
          alert("Something went wrong while generating the image.");
        } finally {
          // Clean up
          // document.body.removeChild(container);
          // newWindow.document.close(); // Close the document to ensure it’s fully loaded.
          // newWindow.focus();
          // newWindow.close();
        }
      }, 3000);
    } else {
      alert("Pop-up blocked! Please allow pop-ups for this website.");
    }

  };


  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    readOperators();
    if (
      ![
        ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
        ACCOUNT_TYPES.DISTRIBUTORS,
        ACCOUNT_TYPES.RETAILERS,
      ].includes(accountType)
    ) {
      readApiProviders();
    }
  }, [readOperators, readApiProviders, accountType]);

  useEffect(() => {
    if (
      ![
        ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
        ACCOUNT_TYPES.DISTRIBUTORS,
        ACCOUNT_TYPES.RETAILERS,
        ACCOUNT_TYPES.API_USERS,
      ].includes(accountType)
    ) {
      readAccounts();
    }
    readRechargeCounts(
      number,
      filterAmount,
      operatorsId,
      transactionsId,
      transactionsStatus,
      startDate,
      endDate,
      apiProvidersId,
      accountsId,
      supervisorsId,
      staffsId
    );
  }, [accountType]);

  useEffect(() => {
    if (!isFiltering) {
      readData(
        number,
        filterAmount,
        operatorsId,
        transactionsId,
        transactionsStatus,
        startDate,
        endDate,
        apiProvidersId,
        accountsId,
        supervisorsId,
        staffsId
      );
      readRechargeCounts(
        number,
        filterAmount,
        operatorsId,
        transactionsId,
        transactionsStatus,
        startDate,
        endDate,
        apiProvidersId,
        accountsId,
        supervisorsId,
        staffsId
      );
    }
  }, [paginationData, readData, readRechargeCounts, accountType]);

  const {
    accountsPermissions,
    appData: { appLogo, appName },
  } = props;

  const canUpdate =
    accountsPermissions.includes(PERMISSION_TYPES.UPDATE) || false;
  const canReload =
    accountsPermissions.includes(PERMISSION_TYPES.RELOAD) || false;
  const canRefund =
    accountsPermissions.includes(PERMISSION_TYPES.REFUND) || false;
  const canRaiseDispute =
    accountsPermissions.includes(PERMISSION_TYPES.RAISE_DISPUTE) || false;
  const canTrack =
    accountsPermissions.includes(PERMISSION_TYPES.TRACK) || false;
  const canExport =
    accountsPermissions.includes(PERMISSION_TYPES.EXPORT) || false;
  const canHeavyReload =
    accountsPermissions.includes(PERMISSION_TYPES.HEAVY_RELOAD) || false;
  const canDownloadInvoice = true;

  const rolesOptions = [{ title: "-- SELECT ROLE --", value: "" }];
  if (accountType === ACCOUNT_TYPES.MASTER_DISTRIBUTORS) {
    [
      {
        id: 3,
        roleName: "Distributors",
      },
      {
        id: 4,
        roleName: "Retailers",
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  } else if (accountType === ACCOUNT_TYPES.DISTRIBUTORS) {
    [
      {
        id: 4,
        roleName: "Retailers",
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  } else {
    [
      {
        id: 2,
        roleName: "Master Distributors",
      },
      {
        id: 3,
        roleName: "Distributors",
      },
      {
        id: 4,
        roleName: "Retailers",
      },
      {
        id: 5,
        roleName: "Api Users",
      },
    ].forEach(({ id, roleName }) =>
      rolesOptions.push({
        title: roleName,
        value: id,
      })
    );
  }

  const staffOptions = [{ title: "-- SELECT STAFF --", value: "" }];
  accounts
    .filter((account) => account?.isDeleted === "No")
    .filter(({ accountsRolesId }) => accountsRolesId === 6)
    .forEach(({ id, firstName, lastName, roleName }) =>
      staffOptions.push({
        title: `${firstName} ${lastName} ( ${roleName} )`,
        value: id,
      })
    );

  const supervisorsOptions = [{ title: "-- SELECT SUPERVISOR --", value: "" }];
  accounts
    .filter((account) => account?.isDeleted === "No")
    .filter((account) =>
      staffsId === "" ? true : account.staffsId === staffsId
    )
    .filter(({ accountsRolesId }) => [2, 3].includes(accountsRolesId))
    .forEach(({ id, firstName, lastName, roleName }) =>
      supervisorsOptions.push({
        title: `${firstName} ${lastName} ( ${roleName} )`,
        value: id,
      })
    );

  const accountsOptions = [{ title: "-- SELECT ACCOUNT --", value: "" }];
  accounts
    .filter((account) => account?.isDeleted === "No")
    .filter(
      (account) =>
        (staffsId === "" ? true : account.staffsId === staffsId) &&
        (supervisorsId === "" ? true : account.createdBy === supervisorsId)
    )
    .filter(({ accountsRolesId }) =>
      rolesId !== ""
        ? accountsRolesId === rolesId
        : [2, 3, 4, 5].includes(accountsRolesId)
    )
    .forEach(({ id, firstName, lastName, mobileNumber, roleName }) =>
      accountsOptions.push({
        title: `${firstName} ${lastName}`,
        value: id,
        subTitle: `${mobileNumber}, ${roleName}`,
      })
    );

  const operatorsOptions = [{ title: "-- SELECT OPERATOR --", value: "" }];
  operators.forEach(({ id, operatorName }) =>
    operatorsOptions.push({
      title: operatorName,
      value: id,
    })
  );

  const apiProvidersOptions = [
    { title: "-- SELECT API PROVIDER --", value: "" },
  ];
  apiProviders.forEach(({ id, providerName }) =>
    apiProvidersOptions.push({
      title: providerName,
      value: id,
    })
  );

  const [showFilters, setShowFilters] = useState(false);
  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  return (
    <>
      <PageHeading
        {...props}
        reloadData={reloadData}
        showExport={canExport}
        onClickExport={onClickExport}
        showHeavyReload={canHeavyReload}
        onClickHeavyReload={onClickHeavyReload}
      />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? "show" : ""}>
        <Form method="POST" action="#" onSubmit={filterData}>
          {![
            ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
            ACCOUNT_TYPES.DISTRIBUTORS,
            ACCOUNT_TYPES.RETAILERS,
            ACCOUNT_TYPES.API_USERS,
          ].includes(accountType) && (
              <>
                {![ACCOUNT_TYPES.STAFF].includes(accountType) && (
                  <Fieldset>
                    <Label>Staff</Label>
                    <Dropdown
                      style={{ border: "1px solid #cacaca" }}
                      placeholder="Staff"
                      value={staffsId}
                      onChange={(value) => {
                        setSupervisorsId("");
                        setRolesId("");
                        setAccountsId("");
                        setStaffsId(value);
                      }}
                      options={staffOptions}
                      disabled={isLoading}
                    />
                  </Fieldset>
                )}
                <Fieldset>
                  <Label>Supervisor</Label>
                  <Dropdown
                    style={{ border: "1px solid #cacaca" }}
                    placeholder="Supervisor"
                    value={supervisorsId}
                    onChange={(value) => {
                      setRolesId("");
                      setAccountsId("");
                      setSupervisorsId(value);
                    }}
                    options={supervisorsOptions}
                    disabled={isLoading}
                  />
                </Fieldset>
              </>
            )}
          {![
            ACCOUNT_TYPES.MASTER_DISTRIBUTORS,
            ACCOUNT_TYPES.DISTRIBUTORS,
            ACCOUNT_TYPES.RETAILERS,
            ACCOUNT_TYPES.API_USERS,
          ].includes(accountType) && (
              <>
                <Fieldset>
                  <Label>Role</Label>
                  <Dropdown
                    style={{ border: "1px solid #cacaca" }}
                    placeholder="Role"
                    value={rolesId}
                    onChange={(value) => {
                      setAccountsId("");
                      setRolesId(value);
                    }}
                    options={rolesOptions}
                    disabled={isLoading}
                  />
                </Fieldset>
                <Fieldset>
                  <Label>Account</Label>
                  <Dropdown
                    style={{ border: "1px solid #cacaca" }}
                    placeholder="Account"
                    value={accountsId}
                    onChange={setAccountsId}
                    options={accountsOptions}
                    disabled={isLoading}
                  />
                </Fieldset>
              </>
            )}
          <Fieldset>
            <Label>Mobile/Account Number</Label>
            <TextInput
              value={number}
              onChange={setNumber}
              placeholder="Mobile/Account Number"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>Amount</Label>
            <NumberInput
              value={filterAmount}
              onChange={setfilterAmount}
              placeholder="Amount"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>Transaction ID</Label>
            <TextInput
              value={transactionsId}
              onChange={setTransactionsId}
              placeholder="Transactions ID"
              maxLength={100}
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>Transaction Status</Label>
            <Dropdown
              style={{ border: "1px solid #cacaca" }}
              placeholder="Transaction Status"
              value={transactionsStatus}
              onChange={setTansactionsStatus}
              options={[
                {
                  title: "-- SELECT STATUS --",
                  value: "",
                },
                {
                  title: "Success",
                  value: "Success",
                },
                {
                  title: "Failure",
                  value: "Failure",
                },
                {
                  title: "Pending",
                  value: "Pending",
                },
              ]}
              disabled={isLoading}
            />
          </Fieldset>

          <Fieldset>
            <Label>API Provider</Label>
            <Dropdown
              style={{ border: "1px solid #cacaca" }}
              placeholder="API Provider"
              value={apiProvidersId}
              onChange={setApiProvidersId}
              options={apiProvidersOptions}
              disabled={isLoading}
            />
          </Fieldset>

          <Fieldset>
            <Label>Operator</Label>
            <Dropdown
              style={{ border: "1px solid #cacaca" }}
              placeholder="Operator"
              value={operatorsId}
              onChange={setOperatorsId}
              options={operatorsOptions}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Start Date</Label>
            <TextInput
              type="date"
              value={startDate}
              onChange={setStartDate}
              placeholder="Start Date"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Label>End Date</Label>
            <TextInput
              type="date"
              value={endDate}
              onChange={setEndDate}
              placeholder="End Date"
              disabled={isLoading === true}
            />
          </Fieldset>
          <Fieldset>
            <Button disabled={isLoading === true} type="submit">
              Filter
            </Button>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <StyledRechargeCountsContainer>
        {rechargeCounts.successAmount && (
          <StyledRechargeCounter color={"forestgreen"}>
            <StyledHeader>{`${formatCurrency(rechargeCounts.successAmount)} ( ${rechargeCounts.successCount
              } )`}</StyledHeader>
          </StyledRechargeCounter>
        )}
        {rechargeCounts.failureAmount && (
          <StyledRechargeCounter color={"red"}>
            <StyledHeader>{`${formatCurrency(rechargeCounts.failureAmount)} ( ${rechargeCounts.failureCount
              } )`}</StyledHeader>
          </StyledRechargeCounter>
        )}
        {rechargeCounts.pendingAmount && (
          <StyledRechargeCounter color={"#ff9800"}>
            <StyledHeader>{`${formatCurrency(rechargeCounts.pendingAmount)} ( ${rechargeCounts.pendingCount
              } )`}</StyledHeader>
          </StyledRechargeCounter>
        )}
      </StyledRechargeCountsContainer>
      <LoadingSpinner
        isLoading={
          !showModal &&
          responseStatus === "" &&
          transactions?.length === 0 &&
          isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILURE &&
          !isLoading &&
          transactions?.length === 0
        }
        message={`No transactions found`}
      />
      {!showModal && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      {transactions?.length > 0 && (
        <>
          <TableBuilder
            isLoading={!showModal && transactions?.length !== 0 && isLoading}
            tableHeadings={[
              {
                title: "Complain",
                dataSelector: "id",
                sticky: true,
                canSort: false,
                width: "100px",
                CellRenderer: (value, item) => (
                  <>
                    {canTrack && (
                      <CustomButton
                        icon={faEye}
                        onClick={() => toggleApiLogs(value)}
                        style={{ color: "orange" }}
                      />
                    )}
                    {canUpdate &&
                      (item.processedStatus === "Success" ||
                        item.processedStatus === "Pending") && (
                        <CustomButton
                          icon={faEdit}
                          onClick={() => {
                            setModalTransactionsId(value);
                            setApiOperatorsId(item.apiOperatorsId);
                            setApiTransactionsId(item.apiTransactionsId);
                            setShowModal(true);
                          }}
                          style={{ color: "#0095ff" }}
                        />
                      )}
                    {canReload && item.processedStatus !== "Failure" && (
                      <CustomButton
                        icon={faRotateRight}
                        onClick={() => reloadTransaction(value)}
                        style={{ color: "#333f7a" }}
                      />
                    )}
                    {canRefund &&
                      (item.processedStatus === "Success" ||
                        item.processedStatus === "Pending") && (
                        <CustomConfirmButton
                          icon={faIndianRupeeSign}
                          title="Refund"
                          message="Are you sure, you want to refund this transaction ?"
                          proceedButtonText="Refund"
                          cancelButtonText="Cancel"
                          onClick={() => refundTransaction(value)}
                          color="forestgreen"
                          hoverColor="#006200"
                        />
                      )}
                    {canDownloadInvoice &&
                        <>
                          <TransactionInvoice
                            invoice={{
                              ...item,
                              id: `print-${item.id}`,
                              lapuNumber: lapuNumber,
                              printApp,
                            }}
                          />
                          <CustomButton
                            icon={faDownload}
                            onClick={() => {
                              setPrintData(item);
                              setLapuNumber(item.lapuNumber);
                              setPrintAmount("");
                              setPrintAppName(appName);
                              setPrintAccountName(item.accountsName);
                              setModalType("PRINT");
                              setPrintApp("");
                              setShowModal(true);
                            }}
                            style={{ color: "#0095ff" }}
                          />
                        </>
                      }
                  </>
                ),
              },
              {
                title: "Mobile/Account Number",
                dataSelector: "rechargeNumber",
                dataType: "string",
                CellRenderer: (value, item) => (
                  <>
                    {value}
                    {item.operatorName && (
                      <StyledSpan>{item.operatorName}</StyledSpan>
                    )}
                    {item.rechargeCircle && item.rechargeCircle !== "null" && (
                      <StyledSpan>{item.rechargeCircle}</StyledSpan>
                    )}
                  </>
                ),
              },
              {
                title: "Transaction Status",
                dataSelector: "processedStatus",
                dataType: "string",
                align: "center",
                CellRenderer: (value) =>
                  value && (
                    <StatusHighliter
                      className={
                        value === "Success"
                          ? "green"
                          : value === "Failure"
                            ? "red"
                            : value === "Pending"
                              ? "yellow"
                              : "blue"
                      }
                    >
                      {value}
                    </StatusHighliter>
                  ),
              },
              {
                title: "API Status",
                dataSelector: "apiStatus",
                dataType: "string",
                align: "center",
                CellRenderer: (value) =>
                  value && (
                    <StatusHighliter
                      className={
                        value === "Success"
                          ? "green"
                          : value === "Failure"
                            ? "red"
                            : value === "Pending"
                              ? "yellow"
                              : "blue"
                      }
                    >
                      {value}
                    </StatusHighliter>
                  ),
              },
              {
                title: "Amount",
                dataSelector: "amount",
                dataType: "number",
                align: "center",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "API Provider",
                dataSelector: "apiProvidersName",
                dataType: "string",
              },
              {
                title: "API Operator ID",
                dataSelector: "apiOperatorsId",
                dataType: "string",
                align: "center",
                CellRenderer: (value) => (value ? value : "N/A"),
              },
              {
                title: "API Users Transaction ID",
                dataSelector: "apiUsersTransactionsId",
                dataType: "string",
                align: "center",
                requiredRoles: [ACCOUNT_TYPES.API_USERS],
                CellRenderer: (value) => (value ? value : "N/A"),
              },
              {
                title: "Transaction Date",
                dataSelector: "createdOn",
                dataType: "date",
                align: "center",
              },
            ]}
            tableData={transactions}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={showModal}
            setModalStatus={() => {
              resetResponseData();
              resetModalForm();
              setShowModal(false);
              setModalType("");
              setLogs([]);
              setPrintApp("");
            }}
            hideCloseButton
          >
            <StyledModalContainer
              width={modalType === "API_LOGS" ? `1200px` : `500px`}
            >
              <h3>
                {modalType === "API_LOGS"
                  ? `API Call Logs`
                  : modalType === "PRINT"
                    ? `Download`
                    : `Update Transaction`}
              </h3>
              {modalType === "API_LOGS" ? (
                <StyledApiCallLogsContainer>
                  <LoadingSpinner
                    isLoading={
                      responseStatus === "" && logs?.length === 0 && isLoading
                    }
                  />
                  <NoData
                    status={
                      responseStatus !== API_RESPONSE_TYPES.FAILURE &&
                      !isLoading &&
                      logs?.length === 0
                    }
                    message={`No api logs found`}
                  />
                  <MessageBox
                    status={responseStatus}
                    message={responseMessage}
                  />
                  {logs?.length > 0 &&
                    logs.map(
                      (
                        {
                          createdOn,
                          processType,
                          request,
                          requestBody,
                          response,
                          responseType,
                          responseTime,
                        },
                        index
                      ) => (
                        <Accordination
                          key={index}
                          header={`${processType}`}
                          autoExpanded={true}
                        >
                          <Grid columns={"calc(50% - 10px) calc(50% - 10px)"}>
                            <GridItem>
                              <StyledBodyContainer>
                                <StyledHeading>
                                  API Request {createdOn && `( ${createdOn} )`}
                                </StyledHeading>
                                <StyledContent>{request}</StyledContent>
                              </StyledBodyContainer>
                              {requestBody && (
                                <StyledBodyContainer>
                                  <StyledHeading>
                                    API Request Body
                                  </StyledHeading>
                                  <StyledContent>{requestBody}</StyledContent>
                                </StyledBodyContainer>
                              )}
                            </GridItem>
                            <GridItem>
                              <StyledBodyContainer>
                                <StyledHeading>
                                  API Response{" "}
                                  {responseTime && `( ${responseTime} )`}
                                </StyledHeading>
                                <StyledContent>
                                  {responseType === "XML" ? (
                                    <code>{response}</code>
                                  ) : (
                                    <JSONPretty
                                      id="json-pretty"
                                      data={response}
                                    ></JSONPretty>
                                  )}
                                </StyledContent>
                              </StyledBodyContainer>
                            </GridItem>
                          </Grid>
                        </Accordination>
                      )
                    )}
                </StyledApiCallLogsContainer>
              ) : modalType === "PRINT" ? (
                <>
                  <FormContainer>
                    <Form method="POST" action="#" onSubmit={printInvoice}>
                      <Fieldset>
                        <Label>Select Provider</Label>
                        <Dropdown
                          value={printApp}
                          onChange={setPrintApp}
                          placeholder="Please select provider"
                          disabled={isLoading}
                          options={[
                            { title: "-- SELECT PROVIDER --", value: "" },
                            { title: "CSC", value: "CSC" },
                            //{ title: "MOBIKWIK", value: "MOBIKWIK" },
                            { title: "MROBOTICS", value: "MROBOTICS" },
                            { title: "REALROBO", value: "REALROBO" },
                            {
                              title: "EZYTM ROBOTICEXCHANGE",
                              value: "ROBOTICEXCHANGE",
                            },
                          ]}
                        />
                      </Fieldset>
                      {printApp && (
                        <Fieldset>
                          <Label>
                            {printApp === "CSC" ? "Operator ID" : "Lapu Number"}
                          </Label>
                          <TextInput
                            value={lapuNumber}
                            onChange={setLapuNumber}
                            placeholder={
                              printApp === "CSC"
                                ? "Please enter Operator ID"
                                : "Please enter Lapu Number"
                            }
                            disabled={isLoading === true}
                          />
                        </Fieldset>)}
                      <Fieldset>
                        <UpdateButton
                          disabled={isLoading}
                          type="submit"
                          style={{ width: "auto" }}
                        >
                          Download
                        </UpdateButton>
                      </Fieldset>
                    </Form>
                  </FormContainer>
                </>
              ) : (
                <FormContainer>
                  <Form method="POST" action="#" onSubmit={updateTransaction}>
                    <Fieldset>
                      <Label required>API Transactions ID</Label>
                      <TextInput
                        value={apiTransactionsId}
                        onChange={setApiTransactionsId}
                        placeholder="Please enter api transactions id"
                        disabled={isLoading === true}
                      />
                    </Fieldset>
                    <Fieldset>
                      <Label required>API Operators ID</Label>
                      <TextInput
                        value={apiOperatorsId}
                        onChange={setApiOperatorsId}
                        placeholder="Please enter api operators id"
                        disabled={isLoading === true}
                      />
                    </Fieldset>
                    {showModal && responseStatus !== "" && (
                      <Fieldset>
                        <MessageBox
                          status={responseStatus}
                          message={responseMessage}
                        />
                      </Fieldset>
                    )}
                    <Fieldset>
                      <UpdateButton
                        disabled={isLoading === true}
                        type="submit"
                        style={{ width: "auto" }}
                      >
                        Update
                      </UpdateButton>
                      <ResetButton
                        disabled={isLoading === true}
                        type="button"
                        onClick={resetModalForm}
                      >
                        Reset
                      </ResetButton>
                    </Fieldset>
                    <OverlayLoader showLoader={showModal && isLoading} />
                  </Form>
                </FormContainer>
              )}
            </StyledModalContainer>
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(TransactionsTable);
